export const constant = {
  ADD_MORE_SECTIONS_TO_SUBSCRIPTION_IN_PROGRESS: "ADD_MORE_SECTIONS_TO_SUBSCRIPTION_IN_PROGRESS",
  ADD_MORE_SECTIONS_TO_SUBSCRIPTION_COMPLETE: "ADD_MORE_SECTIONS_TO_SUBSCRIPTION_COMPLETE",
  ADD_MORE_TIMETABLES_TO_SUBSCRIPTION_IN_PROGRESS: "ADD_MORE_TIMETABLES_TO_SUBSCRIPTION_IN_PROGRESS",
  ADD_MORE_TIMETABLES_TO_SUBSCRIPTION_COMPLETE: "ADD_MORE_TIMETABLES_TO_SUBSCRIPTION_COMPLETE",
  CANCEL_SUBSCRIPTION_IN_PROGRESS: 'CANCEL_SUBSCRIPTION_IN_PROGRESS',
  CANCEL_SUBSCRIPTION_COMPLETE:'CANCEL_SUBSCRIPTION_COMPLETE',
  GET_SUBSCRIPTION_IN_PROGRESS:'GET_SUBSCRIPTION_IN_PROGRESS',
  GET_SUBSCRIPTION_COMPLETED:'GET_SUBSCRIPTION_COMPLETED',
  GET_SUBSCRIPTION_FAILED:'GET_SUBSCRIPTION_FAILED'
};
